
import React from "react";
import { Notification } from "@/types/notification";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface NotificationItemProps {
  notification: Notification;
  onClick: (id: string) => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ 
  notification,
  onClick
}) => {
  const isUnread = !notification.isRead;
  
  return (
    <div 
      className={cn(
        "flex items-start p-3.5 cursor-pointer transition-colors duration-200 hover:bg-muted/50 relative group",
        isUnread ? "bg-primary/5" : ""
      )}
      onClick={() => onClick(notification.id)}
    >
      {isUnread && (
        <span className="absolute left-0 top-0 bottom-0 w-0.5 bg-primary" />
      )}
      
      <div className="flex-grow pr-2">
        <p className={cn(
          "text-sm",
          isUnread ? "font-medium text-foreground" : "text-muted-foreground"
        )}>
          {notification.content}
        </p>
        <span className="text-xs text-muted-foreground mt-1 block">
          {notification.time}
        </span>
      </div>
      
      {isUnread ? (
        <div className="h-2.5 w-2.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></div>
      ) : (
        <Check className="h-4 w-4 text-muted-foreground/50 mt-1 opacity-0 group-hover:opacity-100 transition-opacity" />
      )}
    </div>
  );
};

export default NotificationItem;
